export default __webpack_public_path__ + "static/media/_IMG0325.b2367d4c.jpg";